import React, { useRef, useState } from "react";
import { Dialog } from "@mui/material";

const ImagePopup = ({ selectedImage, onClose }) => {
  const [lensPosition, setLensPosition] = useState({ x: 50, y: 50, visible: false });
  const imgRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!imgRef.current) return;

    const { left, top, width, height } = imgRef.current.getBoundingClientRect();

    // Calculate cursor position as a percentage relative to the image
    const x = ((e.clientX - left) / width) * 100;
    const y = ((e.clientY - top) / height) * 100;

    setLensPosition({ x, y, visible: true });
  };

  const handleMouseLeave = () => {
    setLensPosition({ ...lensPosition, visible: false });
  };

  return (
    <Dialog
      open={Boolean(selectedImage)}
      onClose={onClose}
      maxWidth="xl"
      fullWidth
      PaperProps={{
        style: { background: "none", boxShadow: "none", overflow: "hidden" },
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding:"10px",
          gap:"20px",
          position: "relative",
          width: "100vw",
          height: "100vh",
          
          overflow: "hidden",
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            background: "red",
            color: "white",
            border: "none",
            borderRadius: "50%",
            width: "30px",
            height: "30px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
          }}
        >
          ✖
        </button>

        {/* Left Half - Normal Image */}
        <div
          style={{
            width: "50%",
            height: "80vh",

            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <img
            ref={imgRef}
            src={selectedImage}
            alt="Original Imagee"
            onMouseMove={handleMouseMove}
            onMouseLeave={handleMouseLeave}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              display: "block",
              userSelect: "none",
            }}
          />
        </div>

        {/* Right Half - Magnified Image */}
        <div
          style={{
            width: "50%",
            height: "75vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
          }}
        >
          {lensPosition.visible && (
            <div
              style={{
                width: "100%",
                height: "100%",
                backgroundImage: `url(${selectedImage})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "200%", // Zoom level
                backgroundPosition: `${lensPosition.x}% ${lensPosition.y}%`, // ✅ Fixes misalignment
              }}
            />
          )}
        </div>
      </div>
    </Dialog>
  );
};

export default ImagePopup;
